import * as React from "react";

import "./Button.scss";

const classNameFill = {
  main: "bg-main border-main text-white",
  primary: "bg-primary border-primary text-white",
  secondary: "bg-secondary border-secondary text-white",
  success: "bg-success border-success text-white",
  danger: "bg-danger border-danger text-white",
  warning: "bg-warning border-warning text-black",
  info: "bg-info border-info text-white",
  light: "bg-light border-light text-black",
  dark: "bg-dark border-dark text-white",
  white: "bg-white border-white text-black",
};

const classNameOutline = {
  main: "bg-white border-main text-main",
  primary: "bg-white border-primary text-primary",
  secondary: "bg-white border-secondary text-secondary",
  success: "bg-white border-success text-success",
  danger: "bg-white border-danger text-danger",
  warning: "bg-white border-warning text-warning",
  info: "bg-white border-info text-info",
  light: "bg-transparent border-light text-light",
  dark: "bg-white border-dark text-dark",
};

const classNameSize = {
  lg: "large-button",
  md: "default-button",
  sm: "small-button",
};

const Button = (props) => {
  const {
    children,
    size = "md",
    variant = "main",
    view,
    isIconButton,
    isFullyRounded,
    as = "button",
    type = "button",
    ...rest
  } = props;

  const colorClassName = (() => {
    switch (view) {
      case "clear":
        return `border-0 hover-clear ${classNameOutline[variant]}`;
      case "none":
        return `border-0 hover-none ${classNameOutline[variant]}`;
      case "outline":
        return classNameOutline[variant];
      default:
        return classNameFill[variant];
    }
  })();

  const Component = as;

  return (
    <Component
      className={`button-component border ${
        isFullyRounded ? "full-round" : ""
      } ${isIconButton ? "icon-button" : ""} ${colorClassName} ${
        classNameSize[size] || ""
      }`}
      type={type}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Button;
